import type { DatePicker } from 'antd';
import type { FilterDropdownProps } from '../../types';
import type { TimeFilterFormValue } from './types';
import type { ComponentRef } from 'react';
import { useFilterDropdown } from '../../hooks/use-filter-dropdown';
import { FilterForm } from '../FilterForm';
import { TimeFilterFields } from './filter-fields';
import {
  getInitialFormValues,
  getFilterToSubmit,
  getFilterToReset,
} from './TimeFilterDropdown.utils';

export const TimeFilterDropdown = (props: FilterDropdownProps) => {
  const { form, focusRef, onSubmit, onReset } = useFilterDropdown<
    TimeFilterFormValue,
    ComponentRef<typeof DatePicker>
  >({
    ...props,
    getInitialFormValues,
    getFilterToSubmit,
    getFilterToReset,
  });

  return (
    <FilterForm form={form} filterType={props.filter.type} onSubmit={onSubmit} onReset={onReset}>
      <TimeFilterFields form={form} focusRef={focusRef} options={props.filter.options} />
    </FilterForm>
  );
};
